import { render } from "./NewsFeedStandard.vue?vue&type=template&id=4ef10022&scoped=true"
import script from "./NewsFeedStandard.vue?vue&type=script&lang=js"
export * from "./NewsFeedStandard.vue?vue&type=script&lang=js"

import "./NewsFeedStandard.vue?vue&type=style&index=0&id=4ef10022&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef10022"]])

export default __exports__